import React from 'react';
import { useI18n } from '../i18n/I18nProvider.jsx';

export default function Hero() {
  const { t } = useI18n();
  const mock = t('hero.mock');
  return (
    <section className="hero">
      <div className="hero__inner">
        <div className="hero-text">
          <div className="badge">{t('hero.badge')}</div>
          <h2 dangerouslySetInnerHTML={{ __html: t('hero.title') }} />
          <p className="sub">{t('hero.sub')}</p>
          <div className="hero-btns">
            <a href="https://flautreach.com/auth"><button className="btn-primary">{t('hero.ctaPrimary')}</button></a>
            <a href="https://flautreach.com/auth"><button className="btn-outline">{t('hero.ctaSecondary')}</button></a>
          </div>
        </div>
        <div className="hero-visual">
          {Array.isArray(mock) && mock.map((n, i) => (
            <div className="mock-notif" key={i} style={{ animationDelay: `${0.2 + i * 0.3}s` }}>
              <div className="n-icon" style={{ background: n.color }}>{n.icon}</div>
              <div className="n-body">
                <h4>{n.title}</h4>
                <p>{n.body}</p>
                <span className="tag">{n.tag}</span>
              </div>
              <div className="n-time">{n.time}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}